import classnames from '../utils/classnames.tsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StatsRoot = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('flex flex-col w-full gap-6', className)} {...props} />;
};

const StatsBar = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return (
        <div
            className={classnames('flex gap-0.5 h-4 rounded overflow-hidden bg-surface-strong', className)}
            {...props}
        />
    );
};

const StatsBarSection = ({
    className,
    count,
    totalCount,
    ...props
}: React.ComponentPropsWithRef<'div'> & { count: number; totalCount: number }) => {
    const percentage = totalCount ? (count / totalCount) * 100 : totalCount === 0 ? 100 : 0;
    if (percentage === 0 && totalCount !== 0) return null;
    return <div className={classnames('h-4', className)} style={{ width: `${percentage}%` }} {...props} />;
};

const StatsGroup = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('flex flex-col p-5 gap-3 bg-surface-medium rounded', className)} {...props} />;
};

const StatsRow = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return (
        <div
            className={classnames('flex justify-between gap-1 items-center text-content-strong text-sm"', className)}
            {...props}
        />
    );
};

const StatsDivider = ({ className, ...props }: React.ComponentPropsWithRef<'hr'>) => {
    return <hr className={classnames('my-1 border-line-weak', className)} {...props} />;
};

const StatsLabel = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('text-sm text-content-strong', className)} {...props} />;
};

const StatsValue = ({
    className,
    count,
    totalCount,
    ...props
}: React.ComponentPropsWithRef<'div'> & { count: number; totalCount: number }) => {
    const { i18n } = useTranslation();
    const percentage = totalCount ? (count / totalCount) * 100 : 0;
    return (
        <div className={classnames('flex gap-2 text-sm', className)} {...props}>
            <span className="text-content-strong font-medium">{count?.toLocaleString(i18n.language)}</span>
            <span className="text-content-medium w-10 text-right">({Math.round(percentage)}%)</span>
        </div>
    );
};

export default Object.assign(StatsRoot, {
    Bar: StatsBar,
    BarSection: StatsBarSection,
    Group: StatsGroup,
    Row: StatsRow,
    Divider: StatsDivider,
    Label: StatsLabel,
    Value: StatsValue,
});
